// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var BrowserComponents_UserInitials = require("../../../../shared-browser/src/components/BrowserComponents_UserInitials.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.borderBottom(BrowserStyle.px(1), "dashed", {
              TAG: /* Grey */2,
              _0: /* Light */3
            }),
        tl: {
          hd: BrowserStyle.padding2(BrowserStyle.Spacing.medium, BrowserStyle.zero),
          tl: /* [] */0
        }
      }
    });

var primaryTextContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: /* [] */0
    });

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* Medium */3, /* Bold */2);
}

var primaryText = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
          hd: BrowserStyle.textAlign("left"),
          tl: /* [] */0
        }));

var initials = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundColor({
            TAG: /* Blue */0,
            _0: /* Darkest */0
          }),
      tl: /* [] */0
    });

var secondaryText = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Medium */3, undefined)({
          hd: BrowserStyle.textAlign("left"),
          tl: /* [] */0
        }));

var Styles = {
  container: container,
  primaryTextContainer: primaryTextContainer,
  primaryText: primaryText,
  initials: initials,
  secondaryText: secondaryText
};

function WebComponents_SettingsListRow(Props) {
  var firstName = Props.firstName;
  var isRemovableOpt = Props.isRemovable;
  var lastName = Props.lastName;
  var layoutOpt = Props.layout;
  var onClickEdit = Props.onClickEdit;
  var onClickRemove = Props.onClickRemove;
  var primaryText$1 = Props.primaryText;
  var removeButtonTextOpt = Props.removeButtonText;
  var secondaryText$1 = Props.secondaryText;
  var isRemovable = isRemovableOpt !== undefined ? isRemovableOpt : true;
  var layout = layoutOpt !== undefined ? layoutOpt : /* Desktop */2;
  var removeButtonText = removeButtonTextOpt !== undefined ? removeButtonTextOpt : "Remove";
  return React.createElement(BrowserComponents_FlexRow.make, {
              className: container,
              children: null
            }, layout >= 2 ? Relude_Option.getOrElse(null, Curry._2(Relude_Option.mapTuple2, (function (firstName, lastName) {
                          return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_UserInitials.make, {
                                          className: initials,
                                          firstName: firstName,
                                          lastName: lastName
                                        }), React.createElement(BrowserComponents_Spacer.make, {
                                          size: /* Small */3
                                        }));
                        }), [
                        firstName,
                        lastName
                      ])) : null, React.createElement(BrowserComponents_FlexColumn.make, {
                  className: primaryTextContainer,
                  children: null
                }, React.createElement(BrowserComponents_Text.make, {
                      className: primaryText,
                      children: primaryText$1
                    }), Relude_Option.fold(null, (function (secondaryText$2) {
                        return React.createElement(BrowserComponents_Text.make, {
                                    className: secondaryText,
                                    children: secondaryText$2
                                  });
                      }), secondaryText$1)), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), layout >= 2 ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Button.make, {
                        actionPriority: /* Primary */0,
                        onClick: (function (param) {
                            return onClickEdit;
                          }),
                        size: /* Small */0,
                        title: "Edit"
                      }), isRemovable ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                              size: /* Small */3
                            }), React.createElement(BrowserComponents_Button.make, {
                              actionPriority: /* LegacySecondary */2,
                              onClick: (function (param) {
                                  return onClickRemove;
                                }),
                              size: /* Small */0,
                              title: removeButtonText
                            })) : null) : React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Button.Icon.make, {
                        icon: {
                          TAG: /* Small */1,
                          _0: {
                            TAG: /* Shift */6,
                            _0: /* PencilEdit */16
                          }
                        },
                        iconColor: {
                          TAG: /* Teal */6,
                          _0: /* Medium */2
                        },
                        onClick: (function (param) {
                            return onClickEdit;
                          })
                      }), isRemovable ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                              size: /* Medium */4
                            }), React.createElement(BrowserComponents_Button.Icon.make, {
                              icon: {
                                TAG: /* Small */1,
                                _0: {
                                  TAG: /* Misc */4,
                                  _0: /* Trash */16
                                }
                              },
                              iconColor: {
                                TAG: /* Teal */6,
                                _0: /* Medium */2
                              },
                              onClick: (function (param) {
                                  return onClickRemove;
                                })
                            })) : null));
}

var make = WebComponents_SettingsListRow;

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
